import { Color, LineCap, LineJoin } from '@tencent/alloy-renderer';
import { Direction } from '@tencent/alloy-renderer-tdoc';
import { TextDirectionType } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/text-style-type';
import { IFilterDisplayOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-graphic/filter/filter-display-scene';
import { IGradFill, IImageFill, IImageTile, IPattFill } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import { ILineEndType } from '@src/slide/infrastructure/module/dependent/line-info/endStyle';

export interface IFrame {
    left: number;
    top: number;
    width: number;
    height: number;
    flipH?: boolean;
    flipV?: boolean;
    rotate?: number;
}

export declare type IColor = Color | null;

export interface ISolidFill {
    color: IColor;
}

/**
 * fillStyle应该多选一
 */
export interface IFillStyle {
    // 纯色填充
    solidFill?: ISolidFill | null;
    // 渐变填充
    gradFill?: IGradFillGraphic;
    // 图片填充
    imageFill?: IImageFillGraphic;
    // 图案填充
    pattFill?: IPattFill;
    // 无填充
    noFill?: boolean;
}

export interface IGradFillGraphic extends IGradFill {
    lin?: {
        start?: {
            x: number;
            y: number;
        };
        end?: {
            x: number;
            y: number;
        }
        scaled: number;
    };
    radialOptions?: {
        startCircle: IRadialCircle,
        endCircle: IRadialCircle,
    },
}

export interface IImageFillGraphic extends IImageFill {
    nonStandardParams?: any;
}

export interface ITileImageFillGraphic extends IImageFillGraphic {
    tile: IImageTile;
}

export interface IRadialCircle {
    x: number;
    y: number;
    radius: number;
}

export enum LineCapType {
    BUTT = 'butt',          // 平
    SQUARE = 'square',      // 方
    ROUND = 'round',        // 圆
}

export enum LineJoinType {
    MITER = 'miter',        // 斜角
    ROUND = 'round',        // 圆角
    BEVEL = 'bevel',        // 棱台
}

export interface ILineStyle {
    lineCap: LineCap;   // 线端类型
    lineJoin: LineJoin; // 连接类型
    lineWidth: number;  // 线条宽度
    fillStyle: IFillStyle;  // 线条填充方式
    headEnd?: { // 开始箭头
        lineEndType: ILineEndType;
    };
    tailEnd?: { // 结尾箭头
        lineEndType: ILineEndType;
    };
    lineDash: string[];
    needExpandEventArea?: boolean;
}

export interface IShadowGraphic {
    algn?: any; // 效果原点位置
    blur: number;
    angle: number;
    distance: number;
    scaleX: number;
    scaleY: number;
    isOuter: boolean;
    color: IColor;
    skewX?: number; // X轴倾斜量
    skewY?: number; // Y轴倾斜量
    originX?: number;
    originY?: number;
}

export interface IGlowGraphic {
    color: IColor;
    size: number;
}

export interface ISoftEdgeGraphic {
    size: number;
}

// 映像
export interface IReflectionGraphic {
    algn?: any;
    blur: number;
    angle?: number;
    distance: number;
    endOpacity?: number;
    startOpacity: number;
    radius: number;
    sy?: number;
    rotateWithElement: boolean; // 映像是否跟随形状旋转
    direction: Direction;       // 映像方向，水平/垂直
    flip: boolean;              // 映像是否在当前方向翻转
}
export interface IEffectGraphic {
    shadow?: IShadowGraphic;
    glow?: IGlowGraphic;
    softEdge?: ISoftEdgeGraphic;
    reflection?: IReflectionGraphic;
}

export interface IGraphicModel {
    frame: IFrame;
    svgPath: string;
    fillStyle?: IFillStyle;
    lineStyle?: ILineStyle;
    effect?: IEffectGraphic;
    scaleX: number;
    scaleY: number;
    strokeScale: number;
    image?: IImageFilter;
    notFillImage?: boolean;
    slideKey?: string;
    forbidFilter?: boolean;
}

export interface IImageFilter {
    brightness: number;
    colorTemperature: number;
    contrast: number;
    saturate: number;
    sharpenSoften: number;
}
